const PENDING = 'pending'
const ACCEPTED = 'accepted'
const DECLINED = 'declined'
const CANCELLED = 'cancelled'

export default {
  PENDING,
  ACCEPTED,
  DECLINED,
  CANCELLED,
}
